import React from 'react';

import { RecurrenceEnum } from 'routes/HumanResourcesModule/Settings/HrPositionMapping/helpers/constants';

import { SimulationAgentData } from 'routes/HumanResourcesModule/Simulation/SimulationSynthesis/Agents/helpers/types';
import { FormState } from 'routes/HumanResourcesModule/Simulation/SimulationSynthesis/Agents/components/AddHypotheses/AgentHypothesisModal/AgentHypothesisModal';
import AgentDepartureHypothesisForm from './AgentDepartureHypothesisForm';
import { HrSimulation } from 'routes/HumanResourcesModule/Simulation/helpers/types';

type Props = {
    hrSimulation: HrSimulation;
    agentData: SimulationAgentData;
    formState: FormState;
    setFormState: React.Dispatch<React.SetStateAction<FormState>>;
    recurrence: RecurrenceEnum;
};

const AgentDepartureHypothesisModal = ({
    hrSimulation,
    agentData,
    formState,
    setFormState,
    recurrence,
}: Props): React.ReactElement => (
    <>
        <AgentDepartureHypothesisForm
            hrSimulation={hrSimulation}
            agentData={agentData}
            formState={formState}
            setFormState={setFormState}
            recurrence={recurrence}
        />
    </>
);

export default AgentDepartureHypothesisModal;
